import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import {
  DeliverooSyncLogFilterForm,
  DeliverooSyncLogTable,
} from 'components/logsDeliverooSync'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { FILTER_FIELD_DELIVEROO_SYNC_LOG } from 'components/logsDeliverooSync/deliverooSyncLogFilterForm'
import { FilterMeta } from 'utils/helpers'
import { Button } from 'components/common'
import { ExportIcon } from 'components/icons'
import { downloadDeliverooSyncLogs } from 'utils/api/logsApi'
import { useQuery } from 'hooks'

const DeliverooSyncLog = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()
  const { getQuery } = useQuery()

  const handleExport = async () => {
    const loadingToast = toast.loading('Loading..')
    try {
      const logFilter = getQuery(FILTER_FIELD_DELIVEROO_SYNC_LOG)

      await downloadDeliverooSyncLogs(logFilter || undefined)
      toast.success('File will be sent to you in email!', { id: loadingToast })
    } catch (error) {
      toast.error('File Downloading Failed.', { id: loadingToast })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Deliveroo Sync Logs </title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Deliveroo Sync Logs</div>

        <div className="flex flex-wrap items-center justify-end gap-1">
          <ClearFiltersButton filterKey={FILTER_FIELD_DELIVEROO_SYNC_LOG} />
          <Button
            type="button"
            buttonText="Export"
            variant="custom"
            iconClassName="!h-5 !w-5 text-dataTableIcon"
            icon={<ExportIcon />}
            className="rounded-lg px-3.5 py-2 text-sm font-semibold text-sidebar-primary hover:bg-gray-200"
            onClick={handleExport}
          />
        </div>
      </div>

      <DeliverooSyncLogFilterForm filterMeta={filterMeta} />
      <DeliverooSyncLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default DeliverooSyncLog
